import axios from 'axios';
import { backendUrl } from '../custom/constants/urls';

let cachedAdminRoles: string[] = [];
let lastFetched = 0;
const CACHE_DURATION = 5 * 60 * 1000;

export const fetchAdminRoles = async (): Promise<string[]> => {
  const now = Date.now();
  
  if (cachedAdminRoles.length > 0 && now - lastFetched < CACHE_DURATION) {
    return cachedAdminRoles;
  }

  try {
    const response = await axios.get(`${backendUrl}/admin/roles/admin-roles`);
    if (response.data.success) {
      cachedAdminRoles = response.data.data;
      lastFetched = now;
      return cachedAdminRoles;
    }
  } catch (error) {
    console.warn('Failed to fetch admin roles, using fallback');
  }

  const fallbackRoles = ['admin', 'system admin', 'super admin', 'ceo', 'manager', 'customer support agent'];
  return fallbackRoles;
};

export const isAdminRole = async (roleName: string): Promise<boolean> => {
  if (!roleName) return false;
  
  const adminRoles = await fetchAdminRoles();
  return adminRoles.includes(roleName.toLowerCase());
};

export const clearAdminRolesCache = (): void => {
  cachedAdminRoles = [];
  lastFetched = 0;
};
